import React, { createContext, useContext,  useState } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [isFiltered, setIsFiltered] = useState(false);
  const [filterKey, setFilterKey] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [filteredTableData, setFilteredTableData] = useState(tableData);
  const [mailID, setMailID] = useState('');
  const [upName, setUpName] = useState('');
  const [loggedInMail, setLoggedInMail] = useState('');
  const [loggedInUPN, setLoggedInUPN] = useState('');
  const [loggedInName, setLoggedInName] = useState('');
  const [accessToken, setAccessToken] = useState('');
  const [idToken, setIdToken] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [reportType,setReportType] = useState('Direct Reports');

  const [filterValues, setFilterValues] = useState({
    managerName: '',
    userName: '',
    jobLevel: '',
    location: ''
  });
  

  const toggleFilter = (key) => {
    if (key) {
      setIsFiltered(true);
      setFilterKey(key);
    } else {
      setIsFiltered(false);
      setFilterKey(null);
    }
  };

  const filterTableData = (key) => {
   // console.log(key);
    let filteredResults = [];
      if (reportType === 'Direct Reports') {
        filteredResults = tableData.filter(item => {
         return (
           item.managerEmail && item.managerEmail.toString().toLowerCase() === upName.toString().toLowerCase()
         );
       });
     }
     else if (reportType === 'Indirect Reports') {
        filteredResults = tableData.filter(item => {
         return (
           item.managerEmail && item.managerEmail.toString().toLowerCase() !== upName.toString().toLowerCase()
         );
       });
     }
     else {
       filteredResults = tableData;
     }
    if (key) {
      const filteredData = filteredResults.filter((item) => item.nineboxmapping === key);
      setFilteredTableData(filteredData);
    }
    else {
      setFilteredTableData(filteredResults);
    }
  };

  const filterTableDataBySummary = (filterType) => {
    let filteredResults = [];
      if (reportType === 'Direct Reports') {
        filteredResults = tableData.filter(item => {
         return (
           item.managerEmail && item.managerEmail.toString().toLowerCase() === upName.toString().toLowerCase()
         );
       });
     }
     else if (reportType === 'Indirect Reports') {
        filteredResults = tableData.filter(item => {
         return (
           item.managerEmail && item.managerEmail.toString().toLowerCase() !== upName.toString().toLowerCase()
         );
       });
     }
     else {
       filteredResults = tableData;
     }
    if (filterType === 'Top Talent') {
      const filteredData = filteredResults.filter((item) => item.nineboxmapping === 'Top Talent' || item.nineboxmapping === 'Expandable' || item.nineboxmapping === 'Promotable');
      setFilteredTableData(filteredData);
    }
    else if (filterType === 'Consistent') {
      const filteredData = filteredResults.filter((item) => item.nineboxmapping === 'Solid Performer' || item.nineboxmapping === 'Suitably Placed' || item.nineboxmapping === 'Valued Professional');
      setFilteredTableData(filteredData);
    }
    else if (filterType === 'Observe') {
      const filteredData = filteredResults.filter((item) => item.nineboxmapping === 'Needs Improvement' || item.nineboxmapping === 'Needs Performance Management' || item.nineboxmapping === 'Poor Fit');
      setFilteredTableData(filteredData);
    }
  };





  const AdvanceFilter = (filterType, value) => {
   // console.log(value);
   const updatedFilterValues = {
    ...filterValues,
    [filterType]: value
  };
  setFilterValues(updatedFilterValues);

    console.log(filterValues);
    let filteredResults = [];
    if (reportType === 'Direct Reports') {
      filteredResults = tableData.filter(item => {
       return (
         item.managerEmail && item.managerEmail.toString().toLowerCase() === upName.toString().toLowerCase()
       );
     });
   }
   else if (reportType === 'Indirect Reports') {
      filteredResults = tableData.filter(item => {
       return (
         item.managerEmail && item.managerEmail.toString().toLowerCase() !== upName.toString().toLowerCase()
       );
     });
   }
   else {
     filteredResults = tableData;
   }

    const filteredData = filteredResults.filter((item) => {
      return (
        (updatedFilterValues.managerName === '' || item.managerName.toLowerCase().includes(updatedFilterValues.managerName.toLowerCase())) &&
            (updatedFilterValues.userName === '' || item.userName.toLowerCase().includes(updatedFilterValues.userName.toLowerCase())) &&
            (updatedFilterValues.jobLevel === '' || item.jobLevel.toLowerCase().includes(updatedFilterValues.jobLevel.toLowerCase())) &&
            (updatedFilterValues.location === '' || item.location.toLowerCase().includes(updatedFilterValues.location.toLowerCase()))
        );
    });

    setFilteredTableData(filteredData);
  };

  return (
    <AppContext.Provider value={{ reportType,setReportType, loggedInName, setLoggedInName, loggedInMail, loggedInUPN, setLoggedInMail, setLoggedInUPN,  isFiltered, filterKey, toggleFilter, tableData, setTableData, filteredTableData, setFilteredTableData, filterTableDataBySummary, filterTableData, AdvanceFilter, upName, setUpName, mailID, setMailID, accessToken, setAccessToken, isAdmin, setIsAdmin, idToken, setIdToken }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  return useContext(AppContext);
};
